import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [

]

//分销路由
const distributorsRoutes = [
  //业绩明细
  {
    path: '/atmDistributors/performanceDetail',
    name: 'performanceDetail',
    component: () => import('../view/atmDistributors/performanceDetail/index.vue'),
  },
  //业绩明细导出记录
  {
    path: '/atmDistributors/performanceDetail/record',
    name: 'performanceDetailRecord',
    component: () => import('../view/atmDistributors/performanceDetail/record.vue'),
  },
  //分销员明细
  {
    path: '/atmDistributors/distributorsDetail',
    name: 'distributorsDetail',
    component: () => import('../view/atmDistributors/distributorsDetail/index.vue'),
  },
  //分销提现审核
  {
    path: '/atmDistributors/withdrawRecord',
    name: 'withdrawRecord',
    component: () => import('../view/atmDistributors/withdrawRecord/index.vue'),
  },
  //分销商品管理
  {
    path: '/atmDistributors/distGoodsManage',
    name: 'distGoodsManage',
    component: () => import('../view/atmDistributors/distGoodsManage/index.vue'),
  },
  //分销商品分组
  {
    path: '/atmDistributors/distGoodsGroup',
    name: 'distGoodsGroup',
    component: () => import('../view/atmDistributors/distGoodsGroup/index.vue'),
  },
  //分销商品管理
  {
    path: '/atmDistributors/distGoodsGroup/goodsManage',
    name: 'distGoodsGroup',
    component: () => import('../view/atmDistributors/distGoodsGroup/goodsManage.vue'),
  },
  //分销模式设置
  {
    path: '/atmDistributors/distModel',
    name: 'distModel',
    component: () => import('../view/atmDistributors/distModel/index.vue'),
  },
  //分佣规则
  {
    path: '/atmDistributors/commissionRule',
    name: 'commissionRule',
    component: () => import('../view/atmDistributors/commissionRule/index.vue'),
  },
  //分佣规则新建
  {
    path: '/atmDistributors/commissionRule/create',
    name: 'commissionRule',
    component: () => import('../view/atmDistributors/commissionRule/create.vue'),
  },
  //分销员管理
  {
    path: '/atmDistributors/distPeopleManage',
    name: 'distPeopleManage',
    component: () => import('../view/atmDistributors/distPeopleManage/index.vue'),
  },
  //分销员管理--分销员详情
  {
    path: '/atmDistributors/distInfo',
    name: 'distInfo',
    component: () => import('../view/atmDistributors/distPeopleManage/distInfo.vue'),
  },
  //分销员管理--批量导入
  {
    path: '/atmDistributors/distBatchImport',
    name: 'distBatchImport',
    component: () => import('../view/atmDistributors/distPeopleManage/distBatchImport.vue'),
  },
  //分销员管理--分销员导出记录
  {
    path: '/atmDistributors/distpeopleExportRecord',
    name: 'distpeopleExportRecord',
    component: () => import('../view/atmDistributors/distPeopleManage/distpeopleExportRecord.vue'),
  },
  //分销员管理--招募设置
  {
    path: '/atmDistributors/distRecruitSetting',
    name: 'distRecruitSetting',
    component: () => import('../view/atmDistributors/distPeopleManage/distRecruitSetting.vue'),
  },
  //分组标签
  {
    path: '/atmDistributors/grounpTags',
    name: 'grounpTags',
    component: () => import('../view/atmDistributors/grounpTags/index.vue'),
  },
  //分销员审核
  {
    path: '/atmDistributors/distAudit',
    name: 'distAudit',
    component: () => import('../view/atmDistributors/distAudit/index.vue'),
  },
  //分销员审核导出记录
  {
    path: '/atmDistributors/distAuditExportRecord',
    name: 'distAuditExportRecord',
    component: () => import('../view/atmDistributors/distAudit/distAuditExportRecord.vue'),
  },
  //客户关系
  {
    path: '/atmDistributors/peopleRelation',
    name: 'peopleRelation',
    component: () => import('../view/atmDistributors/peopleRelation/index.vue'),
  },
  //客户关系导出记录
  {
    path: '/atmDistributors/peopleRelationExportRecord',
    name: 'peopleRelation',
    component: () => import('../view/atmDistributors/peopleRelation/peopleRelationExportRecord.vue'),
  },
]
let mergeRoutes = [...routes,...distributorsRoutes]
const router = new VueRouter({
  routes,
  // routes:mergeRoutes //若需本地启动查看页面，请放开
});
export default router;